export default "__VITE_ASSET__CzasrTlC__"